// src/App.js

import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Spinner from './components/Spinner'; // ✅ Use your Spinner component
import './styles/App.css';

// Lazy-loaded pages
const CatalogItemTypeList = lazy(() => import('./pages/CatalogItemTypeList'));
const CatalogItemList = lazy(() => import('./pages/CatalogItemList'));
const CatalogItemDetails = lazy(() => import('./pages/CatalogItemDetails'));

// Optional admin pages
// const AdminLogin = lazy(() => import('./pages/AdminLogin'));
// const Register = lazy(() => import('./pages/Register'));
// const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));

// const isAuthenticated = !!localStorage.getItem('token');

const App = () => {
  return (
    <div className="app-container">
      <Router>
        <Navbar />
        <div className="content">
          <Suspense fallback={<Spinner />}>
            <Routes>
              <Route path="/" element={<CatalogItemTypeList />} />
              <Route path="/:type" element={<CatalogItemList />} />
              <Route path="/:itemtype/:item" element={<CatalogItemDetails />} />

              {/* Optional admin routes */}
              {/*
              <Route path="/nmadminlogin" element={<AdminLogin />} />
              <Route path="/nmadminregister" element={<Register />} />
              <Route
                path="/nmadmin"
                element={isAuthenticated ? <AdminDashboard /> : <Navigate to="/nmadminlogin" />}
              />
              */}

              {/* Redirect all unknown routes to /catalog */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </div>
  );
};

export default App;
